const baseUrl = '/api/';
export const TenantId = 889857;

export const tenantConfig = {
  siteUrl: 'demo.gaipp.com',
  name: 'Gaipp',
  shortName: 'Gaipp',
  logoUrl: 'assets/image/logo.png',
  logoOnly: 'assets/image/logo.png',
  logoPdf: 'assets/image/logo.png',
  email: 'crm@gaipp.com',
  tenantId: TenantId,
  company: 'ELearning tool',
  phone: '6379280538',
  placementEmail: 'placement@gaipp.com',
  landline: '6379280538',
  tenantAddress: '5A, Baskar Complex, 2nd Floor, Besant Road, Chinna Chokkikulam Madurai-2, TamilNadu',
  website: 'https://gaipp.com/',
};

export const registerDetails = {
  registerPlace: 'England & Wales',
  registerNo: '08811442',
  VATRegisterNo: '297924246',
};

export const roleConfig = {
  agent: 'Agent',
  employee: 'Employee',
  student: 'Student',
  admin: 'Admin',
};

export const employeeOfConfig = {
  value: 'gaipp',
  key: 'gaipp',
};

export const APP_URLS = {
  FILE_PATH_LINODE: `https://daipp-data-buckets.eu-central-1.linodeobjects.com/${TenantId}/`,
  login: baseUrl + 'v1/employee/signin',
  tenantSettings: baseUrl + 'tenantsettings',
  tenantPermission: baseUrl + 'tenantPermission',
  forgotPassword: baseUrl + 'employee/forgotPassword',
  groupedList: baseUrl + 'groupedlist',
  student: baseUrl + 'students',
  Courses: baseUrl + 'courses',
  Categories: baseUrl + 'vone/course/category',
  profilePermissions: baseUrl + 'vone/profile/permission',
  CourscesList: baseUrl + 'vone/course/student?filter=',
  favmulti: baseUrl + 'vone/course/favmulti',
  newchapters: baseUrl + 'vone/lmsmain?filter=',
  studentforGotPassword: baseUrl + 'students/forgotPassword?email=',
  getcart: baseUrl + 'vone/course/cart',
  removefromcart: baseUrl + 'vone/course/cart/',
  getManageAddress: baseUrl + 'vone/profile/details',
  addtocart: baseUrl + 'vone/course/cart/',
  updateManaeAddress: baseUrl + 'vone/profile/updateAddress',
  v1: {
    tenantSettings: baseUrl + 'v1/tenantsettings',
    getHelpList: baseUrl + 'v1/help/list',
    userDetails: baseUrl + 'v1/user/details',
    login: baseUrl + 'v1/user/signin',
    changevlepwd: baseUrl + 'v1/user/changevlepassword',
    settingsData: baseUrl + 'v1/settingsdata',
  },
};

export const isEmptyObjectValue = (obj: any): boolean => {
  const arrObj = Object.values(obj);
  for (const elem of arrObj) {
    if (
      elem !== '' &&
      elem !== null &&
      elem !== undefined &&
      elem.toString().trim()
    ) {
      return false;
    }
  }
  return true;
};

/**
 * Checking for file allowed
 */
export const isFileAllowed = (fileName: string, type: string = '') => {
  let _isFileAllowed = false;
  let allowedFiles = [];
  if (type === 'bckUpload') {
    allowedFiles = ['.xls', '.xlsx', '.csv'];
  } else if (type === 'profile_picture'){
    allowedFiles = ['.png', '.jpg', '.jpeg'];
  }
  else {
    allowedFiles = [
      '.ppt',
      '.pptx',
      '.bmp',
      '.doc',
      '.docx',
      '.gif',
      '.jpeg',
      '.jpg',
      '.pdf',
      '.rtf',
      '.png',
      '.tif',
      '.tiff',
      '.txt',
      '.xls',
      '.xlsx',
      '.csv',
    ];
  }

  const regex = /(?:\.([^.]+))?$/;
  const extension = regex.exec(fileName);
  if (undefined !== extension && null !== extension) {
    for (const ext of allowedFiles) {
      if (ext === extension[0]) {
        _isFileAllowed = true;
      }
    }
  }
  return _isFileAllowed;
};

/**
 * Checking for file size
 */
export const isFileSizeAllowed = (size: number) => {
  let _isFileSizeAllowed = false;
  if (size <= 5105344) {
    _isFileSizeAllowed = true;
  }
  return _isFileSizeAllowed;
};

export const validateEmail = (elementValue) => {
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailPattern.test(elementValue);
};

export const sanititzeFileName = (value) => {
  const index = value?.lastIndexOf(TenantId);
  const fileName = value?.substr(index + 7);
  if (index === -1) {
    return value;
  } else {
    return fileName;
  }
};

export const htmlToText = (value) => {
  return value
    ?.replace(/<[^>]+>/g, '')
    ?.replace(/\&nbsp;/g, ' ')
    ?.replace(/\&#160;/g, ' ');
};
